class EOHomeGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.track = this.querySelector('[data-track]');
    this.previousButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.counter = this.querySelector('[data-counter]');
    this.count = this.track?.querySelectorAll('.eo-home__product-slide').length ?? 0;
    if (!this.track || !this.previousButton || !this.nextButton || !this.counter || this.count === 0) return;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.move(event.key === 'ArrowRight' ? 1 : -1);
    });
    this.track.addEventListener('scroll', () => {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.sync());
    }, { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.sync());
    this.resizeObserver.observe(this.track);
    this.sync();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
  }

  get index() {
    if (!this.track?.clientWidth) return 0;
    return Math.max(0, Math.min(this.count - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
  }

  move(direction) {
    const target = Math.max(0, Math.min(this.count - 1, this.index + direction));
    this.track.scrollTo({
      left: target * this.track.clientWidth,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

  sync() {
    const index = this.index;
    this.counter.textContent = `${index + 1} / ${this.count}`;
    this.previousButton.disabled = index === 0;
    this.nextButton.disabled = index === this.count - 1;
  }
}

if (!customElements.get('eo-home-gallery')) customElements.define('eo-home-gallery', EOHomeGallery);

